import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { JiraTicketRequest } from '../models/jiraTicketRequest';
import { SupportEmailRequest } from '../models/supportEmailRequest';

@Injectable({
  providedIn: 'root',
})
export class SupportService {
  private http = inject(HttpClient);

  url: string;

  constructor() {
    this.url = `${environment.apiUrls.workflow}/api/v1/support/`;
  }

  createTicket(request: JiraTicketRequest, attachment?: File): Observable<null> {
    const formData = new FormData();
    formData.append('data', JSON.stringify(request));
    if (attachment !== undefined) {
      formData.append('attachment', attachment);
    }
    return this.http.post<null>(`${this.url}createJiraTicket`, formData);
  }

  sendEmail(email: SupportEmailRequest): Observable<SupportEmailRequest> {
    return this.http.post<SupportEmailRequest>(`${this.url}createSupportEmail`, email);
  }
}
